import { FC, useState } from 'react'

type TextInputProps = {
  label: string
  value: string
  onChange: (name: string, value: string) => void
  id: string
  className?: string
  type?: string
  isValid?: boolean
  errorMessage?: string
}

export const defaultValidate = (value: string): boolean => {
  return !!value
}
export const validateEmail = (email: string): boolean => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase()
  )
}

const TextInput: FC<TextInputProps> = ({
  label,
  onChange,
  id,
  value,
  className = '',
  type = 'text',
  isValid = true,
  errorMessage = 'This field is required'
}) => {
  const inputBorder = isValid ? 'border-gray-200' : 'border-primary-default'
  const labelColor = isValid ? '' : 'text-primary-default'
  const errorClass = isValid ? 'hidden' : 'text-primary-default'
  return (
    <div className={`w-full md:w-1/2 px-3 mb-6 md:mb-0 ${className}`}>
      <label
        htmlFor={id}
        className={`block tracking-wide text-lg mb-2 font-display font-semibold ${labelColor}`}
      >
        {label}
      </label>
      <input
        name={id}
        required
        className={`appearance-none block w-full bg-gray-200 text-gray-700 border ${inputBorder} rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 text-md`}
        id={id}
        value={value}
        type={type}
        onChange={(e) => {
          e.preventDefault()
          const { name, value } = e.target
          onChange(name, value)
        }}
      />
      <div className={errorClass}>{errorMessage}</div>
    </div>
  )
}

export default TextInput
